module.exports = __webpack_public_path__ + "static/img/logo-white.5f29dbbb.png";